<template>
    <div class="lang">
        <div class="reservation-lang">
            <div class="info">
                <h3 class="bullet01">患者信息</h3>
                <div class="input-form mt20">
                    <ul class="input-form__list">
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span> 患者ID <br>
                                    (仅限复诊患者)</div>
                                <div class="cont"><input type="text" class="input" placeholder="患者ID"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span> 姓名</div>
                                <div class="cont item2"><input type="text" class="input" placeholder="名字 姓名"><input type="text" class="input" placeholder="姓氏 姓名"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span> 性别</div>
                                <div class="cont">
                                    <div class="radio-wrap">
                                        <label  ><input type="radio" name="test01" id="test01" checked=""><span class="radio-btn"></span>
                                            <p>男性</p>
                                        </label>
                                        <label  ><input type="radio" name="test01" id="test02"><span class="radio-btn"></span>
                                            <p>女性</p><input type="text" disabled="">
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </li>

                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>出生日期</div>
                                <div class="cont"><input type="text" class="input" placeholder="ex)19800320"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>国籍</div>
                                <div class="cont"><input type="text" class="input"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span> 语言</div>
                                <div class="cont"><input type="text" class="input"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>居住国</div>
                                <div class="cont">
                                    <div class="radio-wrap">
                                        <label  ><input type="radio" name="test01" id="test01" checked=""><span class="radio-btn"></span>
                                            <p>韩国</p>
                                        </label>
                                        <label  ><input type="radio" name="test01" id="test02"><span class="radio-btn"></span>
                                            <p>其他</p><input type="text" disabled="">
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit">母国地址</div>
                                <div class="cont"><input type="text" class="input"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>韩国地址</div>
                                <div class="cont"><input type="text" class="input"></div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>电话号码</div>
                                <div class="cont">
                                    <input type="text" class="input">
                                    <!-- <p>- Please leave korean phone number or email address.</p> -->
                                </div>

                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit">紧急联系人</div>
                                <div class="items">
                                    <div class="cont">
                                        <div class="tit2">姓名</div><input type="text" class="input">
                                    </div>
                                    <div class="cont">
                                        <div class="tit2">与病人的关系</div><input type="text" class="input">
                                    </div>
                                    <div class="cont">
                                        <div class="tit2">电话号码</div><input type="text" class="input">
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>保险信息</div>
                                <div class="cont"><input type="text" class="input"></div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="info">
                <h3 class="bullet01">预约 详细信息</h3>
                <div class="input-form mt20">
                    <ul class="input-form__list">
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>症状 <br>
                                    (预约就诊原因)</div>
                                <div class="cont">
                                    <textarea name="" id="" class="textarea"></textarea>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>所需医疗服务</div>
                                <div class="cont">
                                    <textarea name="" id="" class="textarea"></textarea>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>首选日期和时间</div>
                                <div class="items">
                                    <div class="cont">
                                        <div class="tit2">第1</div>
                                        <div class="table-search type2">
                                            <div class="dp__input_wrap">
                                                <VueDatePicker v-model="showStartDate" locale="en" :format="formatDate" :enable-time-picker="false" week-start="0" position="left" placeholder="ex) 2025-01-01" auto-apply />
                                            </div>
                                            <div class="row">
                                                <div class="select">
                                                    <a href="javascript:;" class="select--btn" :class="{ active: select01 }" @click.prevent="activeselect01">选择小时</a>
                                                    <slide-up-down :active="select01" class="select-option">
                                                        <a href="" class="select-option--btn" v-for="i in 23">{{i}}</a>
                                                    </slide-up-down>
                                                </div>
                                                :
                                                <div class="select">
                                                    <a href="javascript:;" class="select--btn" :class="{ active: select02 }" @click.prevent="activeselect02">选择分钟</a>
                                                    <slide-up-down :active="select02" class="select-option">
                                                        <a href="" class="select-option--btn" v-for="i in 59">{{i}}</a>
                                                    </slide-up-down>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="cont">
                                        <div class="tit2">第2</div>
                                        <div class="table-search type2">
                                            <div class="dp__input_wrap">
                                                <VueDatePicker v-model="showStartDate" locale="en" :format="formatDate" :enable-time-picker="false" week-start="0" position="left" placeholder="ex) 2025-01-01" auto-apply />
                                            </div>
                                            <div class="row">
                                                <div class="select">
                                                    <a href="javascript:;" class="select--btn" :class="{ active: select03 }" @click.prevent="activeselect03">选择小时</a>
                                                    <slide-up-down :active="select03" class="select-option">
                                                        <a href="" class="select-option--btn" v-for="i in 23">{{i}}</a>
                                                    </slide-up-down>
                                                </div>
                                                :
                                                <div class="select">
                                                    <a href="javascript:;" class="select--btn" :class="{ active: select04 }" @click.prevent="activeselect04">选择分钟</a>
                                                    <slide-up-down :active="select04" class="select-option">
                                                        <a href="" class="select-option--btn" v-for="i in 59">{{i}}</a>
                                                    </slide-up-down>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>附加医疗报告</div>
                                <div class="cont">
                                    <input type="text" class="input" style="pointer-events: none;">
                                    <label class="file">
                                        <input type="file">
                                        <div class="main-button c-gray">附加文件</div>
                                    </label>
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>附加链接</div>
                                <div class="cont">
                                    <input type="text" class="input">
                                </div>
                            </div>
                        </li>
                        <li class="input-form__item">
                            <div class="box">
                                <div class="tit"><span class="c-red">* &nbsp;</span>附加图像</div>
                                <div class="cont">
                                    <input type="text" class="input" style="pointer-events: none;">
                                    <label class="file">
                                        <input type="file">
                                        <div class="main-button c-gray">附加文件</div>
                                    </label>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="botton-wrap">
                    <a href="" class="sub-button c-gray">取消</a>
                    <a href="" class="main-button c-main">确认</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import VueDatePicker from '@vuepic/vue-datepicker';
    import '@vuepic/vue-datepicker/dist/main.css';
    import SlideUpDown from 'vue-slide-up-down';

    export default {
        components: {
            VueDatePicker,
            SlideUpDown,
        },
        data() {
            return {
                showStartDate: null, // 초기값 설정
                formatDate: 'yyyy-MM-dd', // 원하는 날짜 형식 설정
                select01: false,
                select02: false,
                select03: false,
                select04: false,
            };
        },
        methods: {
            activeselect01() {
                this.select01 = !this.select01;
            },
            activeselect02() {
                this.select02 = !this.select02;
            },
            activeselect03() {
                this.select03 = !this.select03;
            },
            activeselect04() {
                this.select04 = !this.select04;
            },
        },
    }
</script>